import { defaultSerializeQueryArgs } from "@reduxjs/toolkit/query";

const isForceUpdate = ({patchBody, filter}) => {
    return filter.some(el => Object.hasOwn(patchBody, el.field));
};


export const getQueryCacheKey = ({endpointName, queryArgs, patchBody}) => {

    if(patchBody && queryArgs && queryArgs.filter && isForceUpdate({patchBody, filter: queryArgs.filter})) {
        return null;
    }

    return defaultSerializeQueryArgs({
        endpointName,
        queryArgs
    });
};